import axios from 'axios';

export function billingMonths(month, quarterly = false) {
    if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(month)) throw new Error('Invalid month');
    if (!quarterly) return [month];
    const start = Math.floor((Number(month.slice(5)) - 1) / 3) * 3 + 1;
    return [0, 1, 2].map((offset) => month.slice(0, 4) + '-' + String(start + offset).padStart(2, '0'));
}

export async function fetchBillingPeriod(baseUrl, month, quarterly = false) {
    const results = await Promise.all(billingMonths(month, quarterly).map(async (value) => {
        const res = await axios.get(baseUrl + '/api/admin/cp-settlement/monthly-billing', {
            params: { month: value, includeEmpty: 0, includeDetails: 0 },
            withCredentials: true,
            timeout: 30000,
        });
        if (res?.data?.code !== 1000 || !Array.isArray(res.data?.data?.rows)) {
            throw new Error('Billing query failed');
        }
        return res.data.data.rows;
    }));
    return results.flat();
}

// Preserve the existing merchant-name matching contract and amount aliases.
export function billingAmounts(rows, merchantName, multiplier = 1) {
    return rows.filter((row) => (row.cp_name ?? row.cpName ?? '') === merchantName)
        .reduce((total, row) => ({
            paymentAmount: total.paymentAmount + Math.round(Number(row.payment_completed_amount ?? row.paymentCompletedAmount ?? 0)) * multiplier,
            settlementAmount: total.settlementAmount + Math.round(Number(row.settlement_net_amount ?? row.settlementNetAmount ?? 0)) * multiplier,
            fee: total.fee + Math.round(Number(row.payment_cp_fee_amount ?? row.paymentCpFeeAmount ?? row.settlement_fee_amount ?? 0)) * multiplier,
        }), { paymentAmount: 0, settlementAmount: 0, fee: 0 });
}
